import { YANDEX_MAPS_API_KEY, YANDEX_SUGGEST_API_KEY } from '@/config'
import i18n from '@/utils/i18n'

/* eslint-disable @typescript-eslint/no-explicit-any */
declare global {
  interface Window {
    ymaps: any
  }
}

let loadPromise: Promise<void> | null = null

/** Сообщение об ошибке загрузки Yandex Maps на текущем языке интерфейса. */
export function yandexMapsLoadFailed(): string {
  return i18n.t('mapsErr.loadFailed')
}

/** Сброс кэша загрузки скрипта (повтор после ошибки или смены ключа). */
export function resetYandexMapsLoader(): void {
  loadPromise = null
}

/**
 * Одноразовая загрузка Yandex Maps JS API 2.1 (singleton Promise).
 * Саджест использует тот же ключ через `suggest_apikey` (см. доку Яндекса).
 */
export function loadYandexMaps(): Promise<void> {
  if (loadPromise) return loadPromise
  if (!YANDEX_MAPS_API_KEY) {
    return (loadPromise = Promise.resolve())
  }
  if (window.ymaps?.ready) {
    return (loadPromise = new Promise<void>((resolve) =>
      window.ymaps.ready(resolve),
    ))
  }
  loadPromise = new Promise<void>((resolve, reject) => {
    const script = document.createElement('script')
    const suggestKey = YANDEX_SUGGEST_API_KEY || YANDEX_MAPS_API_KEY
    script.src = `https://api-maps.yandex.ru/2.1/?apikey=${YANDEX_MAPS_API_KEY}&suggest_apikey=${suggestKey}&lang=ru_RU`
    script.async = true
    script.onload = () => {
      if (window.ymaps?.ready) {
        window.ymaps.ready(resolve)
      } else {
        resolve()
      }
    }
    script.onerror = () => {
      try {
        script.remove()
      } catch {
        /* empty */
      }
      loadPromise = null
      reject(new Error(yandexMapsLoadFailed()))
    }
    document.head.appendChild(script)
  })
  return loadPromise
}

export function isYandexMapsApiConfigured(): boolean {
  return Boolean(YANDEX_MAPS_API_KEY)
}
